import { Transition } from "react-transition-group";
import PropTypes from "prop-types";
import React from "react";

const defaultDuration = 300;

const defaultStyle = {
  transition: `opacity ${defaultDuration}ms ease-in-out`,
  opacity: 0,
};

const transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

/**
 * Wrapper component that applies a FadeIn transition to its children
 */
export default function FadeIn({ children }) {
  return (
    <Transition in appear timeout={defaultDuration}>
      { state => (
        <div style={{ ...defaultStyle, ...transitionStyles[state] }}>
          {children}
        </div>
      )}
    </Transition>
  );
}

FadeIn.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
